import { render } from "preact";
import { Booth } from "src/components/Booth";

render(<>
    <Booth position={{width: "50vw"}} onChatOpen={() => {
        console.log("CHAT OPEN!")
    }} boothId="f0c60777-8c71-4a07-ac2e-9df13185da10"/>
</>, document.getElementById("content"))